import React from "react";
import ReactLoading from "react-loading";

const Loading = ({
  type = "spin",
  color = "white",
  isLoading,
  center,
  className,
}) => {
  if (!isLoading) {
    return;
  }
  if (center) {
    return (
      <div className={`w-full flex items-center justify-center ${className}`}>
        <ReactLoading type={type} color={color} height={20} width={20} />
      </div>
    );
  }
  return <ReactLoading type={type} color={color} height={20} width={20} />;
};

export default Loading;
